export default {
  AD: {
    10: '5€',
    20: '9€',
    50: '20€',
    100: '35€',
  },
  ES: {
    10: '5€',
    20: '9€',
    50: '20€',
    100: '35€',
  },
  IT: {
    10: '5€',
    20: '9€',
    50: '20€',
    100: '35€',
  },
  PT: {
    10: '5€',
    20: '9€',
    50: '20€',
    100: '35€',
  },
  FR: {
    10: '6€',
    20: '10€',
    50: '23€',
    100: '38€',
  },
  DE: {
    10: '6€',
    20: '10€',
    50: '23€',
    100: '38€',
  },
  MX: {
    10: 'MX$100',
    20: 'MX$185',
    50: 'MX$400',
    100: 'MX$720',
  },
  CL: {
    10: 'CLP 5,000',
    20: 'CLP 9,000',
    50: 'CLP 20,000',
    100: 'CLP 35,000',
  },
  PE: {
    10: 'PEN 20',
    20: 'PEN 36',
    50: 'PEN 80',
    100: 'PEN 140',
  },
  AR: {
    10: '$5',
    20: '$9',
    50: '$20',
    100: '$35',
  },
  US: {
    10: '$6',
    20: '$10',
    50: '$23',
    100: '$38',
  },
};
